export function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formatjs/intl-utils/lib/src/invariant.js
// module id = 142
// module chunks = 43